import {ContentType} from "@/type";

export default {
    namespaced: true,

    state: {
        nowContent: ContentType.NotificationList,
        nowMonitoring: "VehicleList",
        isContent: true,
        sideBarSelectValue: '',
        isSmallHeader: false,
        showSideBar: true,
        expandedKeyList: []
    },
    getters: {
    },
    mutations: {
        setContent(state, value) {
            state.nowContent = value
        },
        setMonitoring(state, value) {
            state.nowMonitoring = value
        },
        setSideBarSelectValue(state, value){
            state.sideBarSelectValue = value
        },
        showContent(state) {
            state.isContent = true
        },
        hideContent(state) {
            state.isContent = false
        },
        fullHeader(state) {
            state.isSmallHeader = false
        },
        smallHeader(state) {
            state.isSmallHeader = true
        },
        setShowSideBar(state) {
            state.showSideBar = !state.showSideBar
        },
        setSmallSideBar(state) {
            state.showSideBar = false
        },
        setFullSideBar(state) {
            state.showSideBar = true
        },
        setInitContent(state){
            state.nowContent = 0
            state.nowMonitoring = "VehicleList"
            state.isContent = true
            state.sideBarSelectValue = ''
            state.isSmallHeader = false
            state.showSideBar = false
            state.expandedKeyList = []
        },
        setExpandedKeyList(state, value){
            state.expandedKeyList = value
        }
    },
    actions: {

    },
}
